import { useQuery } from "react-query";

import { getMappedMerchantInfoData } from "mappers";
import { creditReviewDetailsService } from "services";
import { ErrorResponse, MerchantInfoDto, MerchantInfoMappedDto } from "types";

type useGetMerchantInfoByCreditReviewIdQueryProps = {
	creditReviewId: string;
	onError?: (error: ErrorResponse) => void;
};

const useGetMerchantInfoByCreditReviewIdQuery = ({
	creditReviewId,
	onError,
}: useGetMerchantInfoByCreditReviewIdQueryProps) => {
	const queryResult = useQuery(
		["creditReviewMerchantInformation", creditReviewId],
		() =>
			creditReviewDetailsService.getMerchantInfo({
				creditReviewId,
			}),
		{
			select: (data: MerchantInfoDto): MerchantInfoMappedDto => {
				return getMappedMerchantInfoData(data);
			},
			onError(error: ErrorResponse) {
				onError?.(error);
			},
			retry: 0,
			enabled: !!creditReviewId,
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useGetMerchantInfoByCreditReviewIdQuery;
